import React from "react";

const Analytics = () => {
    return (
        <>
            This is Analytics Page
        </>
    );
};

export default Analytics;
